import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchResultsComponent } from './search-results.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.searchResults.pageInRouting,
    data: { data: PAGES_AND_PATHS.searchResults },
    component: SearchResultsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./search-results.module').then(m => m.SearchResultsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchResultsRoutingModule { }
